import React, { useEffect, useState } from "react";
import { Modal, Image } from "react-bootstrap";
import BUTTON from "../button/Button.component";
import { DefaultModalProps, IModalProps } from "./Modal.types";
import ModalStyles from "./Modal.styles";
import ExclamationIcon from "../../theme/assets/exclamation.svg";

const OUTAGE_NOT_FOUND_MODAL: React.FC<IModalProps> = (props: IModalProps) => {
  const [show, setShow] = useState(false);
  const { handleClose, centered } = props;

  useEffect(() => {
    setShow(props.show);
  }, [props.show]);

  return (
    <ModalStyles.NotFoundModal
      dialogClassName="not-found-modal"
      show={show}
      centered={centered}
      onHide={handleClose}
    >
      <ModalStyles.NotFoundModalHeader className="not-found-modal-header">
        <div className="icon-container">
          <Image src={ExclamationIcon} />
          <Modal.Title>OOPS!</Modal.Title>
        </div>
      </ModalStyles.NotFoundModalHeader>
      <Modal.Body>Outage not found.</Modal.Body>
      <Modal.Footer>
        <BUTTON variant="primary" onClick={handleClose}>
          View Streetlight Outage Map
        </BUTTON>
      </Modal.Footer>
    </ModalStyles.NotFoundModal>
  );
};

OUTAGE_NOT_FOUND_MODAL.defaultProps = DefaultModalProps;
export default OUTAGE_NOT_FOUND_MODAL;
